import * as pdfjsLib from 'pdfjs-dist';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.min.mjs?url';

// Set up PDF.js worker once, globally
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;

// Export pdfjsLib for consistent usage
export { pdfjsLib };
